import { FileUploaderTheme as baseTheme } from "@acin.reactjs/acin-ui/fileUploader";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const FileUploaderTheme: ComponentCSSStyle<baseTheme> = {
  filename: {
    overflowX: "inherit",
  },
  button: {
    root: {
      borderRadius: "4px 20px 20px 16px",
      "& span": { fontWeight: 600 },
    },
  },
};

export default FileUploaderTheme;
